/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Nav_TicketsInputs */

const en_settings_nav_tickets = /** @type {(inputs: Settings_Nav_TicketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Support Tickets`)
};

const zh_settings_nav_tickets = /** @type {(inputs: Settings_Nav_TicketsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工单支持`)
};

/**
* | output |
* | --- |
* | "Support Tickets" |
*
* @param {Settings_Nav_TicketsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_nav_tickets = /** @type {((inputs?: Settings_Nav_TicketsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Nav_TicketsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_nav_tickets(inputs)
	return zh_settings_nav_tickets(inputs)
});
export { settings_nav_tickets as "settings.nav.tickets" }